import { computed, ComputedRef } from 'vue'
import { useStore } from 'vuex'

import { HistorySourceCodeModuleName } from '@/store/modules/modules'

export class HistorySourceCodeViewModel {
  private store = useStore()

  historySourceCodeList: ComputedRef<{ [judgeId: number]: string }> = computed(
    () => this.store.getters[`${HistorySourceCodeModuleName}/historySourceCodeList`]
  )
  isLoading: ComputedRef<boolean> = computed(() => this.store.getters[`${HistorySourceCodeModuleName}/isLoading`])
  error: ComputedRef<Error | null> = computed(() => this.store.getters[`${HistorySourceCodeModuleName}/error`])

  setHistorySourceCodeList(list: { [judgeId: number]: string }): void {
    this.store.commit(`${HistorySourceCodeModuleName}/setHistorySourceCodeList`, { list })
  }

  isAlreadySourceCodeRequested(judgeId: number): boolean {
    return judgeId in this.historySourceCodeList.value
  }

  async fetchHistorySourceCodeList(judgeId: number): Promise<void> {
    await this.store.dispatch(`${HistorySourceCodeModuleName}/fetchHistorySourceCodeList`, {
      judgeId
    })
  }
}
